import { scheduleProductReview } from './product-reviews.js'

export function createProductCard(hit, { sendEvent, addToCartAriaLabel, listName }) {
  const template = document.getElementById('product-card-template')

  if (!(template instanceof HTMLTemplateElement)) {
    throw new Error('Product card template could not be found.')
  }

  const fragment = template.content.cloneNode(true)
  const card = fragment.firstElementChild

  if (!(card instanceof HTMLElement)) {
    throw new Error('Product card template is invalid.')
  }

  const productId = hit.productId ?? hit.id ?? hit.objectID
  const productUrl = hit.productUrl ?? hit.url ?? '#'
  const thumbnail = hit.thumbnailUrl ?? hit.thumbnail ?? null
  const productName = hit.name ?? ''
  const sku = hit.sku ?? ''
  const properties = Array.isArray(hit.core_properties) ? hit.core_properties.slice(0, 3) : []
  const addToCartUrl = hit.addToCartUrl ?? null

  fillLinks(card, productUrl, hit, sendEvent, listName)
  fillName(card, productName)
  fillPromotion(card, hit.promotion_label)
  fillThumbnail(card, thumbnail, productName)
  fillReviews(card, sku)
  fillProperties(card, properties)
  fillPrice(card, productId)

  fillAddToCart(card, productId, productName, addToCartUrl, addToCartAriaLabel)

  return card
}

function fillLinks(card, productUrl, hit, sendEvent, listName) {
  card.querySelectorAll('[data-product-link]').forEach((link) => {
    link.href = productUrl

    link.addEventListener('click', () => {
      sendEvent('click', hit, 'Product selected')

      window.dispatchEvent(
        new CustomEvent('product.selected', {
          detail: {
            product: {
              sku: hit.ga4_item_id,
              name: hit.name,
              brand: hit.brand,
              categories: hit.ga4_item_categories,
              list: listName,
              index: Number.isInteger(hit.__position) ? hit.__position - 1 : null,
            },
          },
        }),
      )
    })
  })
}

function fillName(card, productName) {
  const element = card.querySelector('[data-product-name]')

  if (element) {
    element.textContent = productName
  }
}

function fillPromotion(card, promotionLabel) {
  if (!promotionLabel) {
    return
  }

  const element = card.querySelector('[data-product-promotion]')

  if (!element) {
    return
  }

  element.textContent = promotionLabel
  element.classList.remove('d-none')
}

function fillThumbnail(card, thumbnail, productName) {
  if (!thumbnail) {
    return
  }

  const image = card.querySelector('[data-product-thumbnail]')
  const placeholder = card.querySelector('[data-product-thumbnail-placeholder]')

  if (image) {
    image.src = thumbnail
    image.alt = productName
    image.classList.remove('d-none')
  }

  placeholder?.remove()
}

function fillReviews(card, sku) {
  const container = card.querySelector('[data-product-reviews]')

  if (!container) {
    return
  }

  const widgetId = container.dataset.productReviewsWidgetId

  if (!sku || !widgetId) {
    container.remove()

    return
  }

  container.dataset.productReviewsSku = sku
  scheduleProductReview(container)
}

function fillProperties(card, properties) {
  if (!properties.length) {
    return
  }

  const list = card.querySelector('[data-product-properties]')

  if (!list) {
    return
  }

  properties.forEach((property) => {
    const item = document.createElement('li')

    item.className = 'd-flex align-items-start gap-2 fs-sm text-body-secondary'

    const icon = document.createElement('i')

    icon.className = 'ci-check text-success flex-shrink-0 mt-1'
    icon.setAttribute('aria-hidden', 'true')

    const text = document.createElement('span')

    text.textContent = property

    item.append(icon, text)
    list.append(item)
  })

  list.classList.remove('d-none')
}

function fillPrice(card, productId) {
  const price = card.querySelector('[data-product-price]')
  const discount = card.querySelector('[data-product-discount]')

  if (price) {
    price.dataset.productPriceId = productId
  }

  if (discount) {
    discount.dataset.productDiscountId = productId
  }
}

function fillAddToCart(card, productId, productName, addToCartUrl, addToCartAriaLabel) {
  const button = card.querySelector('[data-product-add-to-cart]')

  if (!button) {
    return
  }

  button.dataset.productId = productId

  if (addToCartUrl) {
    button.dataset.addToCartUrl = addToCartUrl
  }

  const ariaLabel = addToCartAriaLabel?.replace('{product}', productName) ?? `Voeg ${productName} toe aan de winkelwagen`

  button.setAttribute('aria-label', ariaLabel)
}
